import logo from "../../assets/logo/logo2.png";
import { AiOutlineSearch } from "react-icons/ai";
import IconNotifi from "../iconNotifi/iconNotifi";
import NavbarDawn from "../NavbarDawn/NavbarDawn";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const HeaderIndex = (data) => {
  const navigate = useNavigate();
  const [dniCuil, setDniCuil] = useState();
  const [relation, setRelation] = useState("Socio");

  const handleSearch = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_SEARCH_USER_API}?id=${dniCuil}&relation=${relation}`
      );
      if (res.data) {
        navigate("/informe", { state: res.data });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se encontró el usuario.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response.data.message,
      });
    }
  };

  const handleTypeChange = (e) => {
    setRelation(e.target.value);
  };

  const handleTypesearch = (e) => {
    setDniCuil(e.target.value);
  };

  return (
    <div className="container-top">
      <div className="container-user">
        <IconNotifi />
        <NavbarDawn data={data} />
      </div>
      <div className="container-logo-search">
        <div>
          <img className="logo" src={logo} alt="logo" />
        </div>
        <div className="conatiner-search">
          <input
            className="search"
            placeholder="Ingrese DNI o CUIT"
            value={dniCuil || ""}
            onChange={(e) => handleTypesearch(e)}
          />
          <div className="boxsearch-selec">
            <select
              className="selec-person"
              name="relation"
              onChange={(e) => handleTypeChange(e)}
            >
              <option value="Socio">Socio</option>
              <option value="Proveedor">Proveedor</option>
              <option value="Fondista">Fondista</option>
            </select>
            <button
              className="button-search"
              onClick={handleSearch}
              onChange={setRelation}
            >
              <AiOutlineSearch className="iconsearch" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderIndex;
